import React from "react";
import { Grid } from "@mantine/core";
import "./segment.css";

export const Segments = ({ children }) => {
  return <Grid className="segment-wrapper">{children}</Grid>;
};
